import type { User } from "@/types";
import type { Order } from "@/types/orders";

export enum SupportTicketCategory {
	ORDER = "ORDER",
	HOSTING = "HOSTING",
	PLAN = "PLAN",
	OTHER = "OTHER",
}

export enum SupportTicketStatus {
	OPEN = "OPEN",
	CLOSED = "CLOSED",
}

export type SupportTicketReply = {
	authorId: Pick<User, "_id" | "firstName" | "lastName" | "email" | "avatar" | "role"> | null;
	message: string;
	fileUrls?: string[];
	isStaffReply: boolean;
	createdAt: string;
};

export type SupportTicket = {
	_id: string;
	userId: Pick<User, "_id" | "firstName" | "lastName" | "email" | "avatar" | "role" | "companyName"> | null;
	orderId?: Pick<Order, "id" | "orderStatus" | "createdAt" | "amountTotal" | "items"> & { _id?: string };
	orderItemId?: string;
	ticketNumber: string;
	category: SupportTicketCategory;
	subject: string;
	description: string;
	status: SupportTicketStatus;
	replies: SupportTicketReply[];
	archivedFor?: string[];
	userLastViewedAt?: string;
	staffLastViewedAt?: string;
	lastActivityAt?: string;
	closedAt?: string;
	createdAt: string;
	updatedAt: string;
};

export type SupportTicketCollection = {
	docs: SupportTicket[];
	totalDocs: number;
	limit: number;
	totalPages: number;
	page: number;
	hasPrevPage: boolean;
	hasNextPage: boolean;
};

export type CreateSupportTicketBody = {
	category: SupportTicketCategory;
	orderId?: string;
	orderItemId?: string;
	subject: string;
	description: string;
	fileUrls?: string[];
};
